import React from 'react';
import ReactDOM from 'react-dom';

import {
    HashRouter,
    Route,
    Switch
} from 'react-router-dom';


import Signin from './views/Quiz/Signin';
import ChangeP from './views/Quiz/ChangeP';
import App from './containers/App/App.jsx';
import CreateUser from './views/Quiz/CreateUser';

import './assets/css/bootstrap.min.css';
import './assets/css/animate.min.css';
import './assets/sass/light-bootstrap-dashboard.css';
import './assets/css/demo.css';
import './assets/css/pe-icon-7-stroke.css';

ReactDOM.render((
    <HashRouter>
        <Switch>
            <Route path="/login" name="Login" component={Signin}/>
            <Route path="/change" name="Change Password" component={ChangeP}/>
            <Route path="/create" name="Create User" component={CreateUser}/>
            <Route path="/" name="Dash Board" component={App}/>
        </Switch>
    </HashRouter>
),document.getElementById('root'));



// WEBPACK FOOTER //
// ./src/index.js